import { Harpic, checkDocument, hasOwn } from '../../customLib';
import { actionsRequired as getActionsRequired } from '../../cred';

const marginActionsSeen = new Set();
const depActionsSeen = new Set();
const withActionsSeen = new Set();
const depActionsUSDTSeen = new Set();
const withActionsUSDTSeen = new Set();
const profileActionsSeen = new Set();

export const initialActionsRequired = {
	marginOnGoing: [],
	marginInFreeze: false,
	marginInDepo: false,
	marginAboutToExpire: [],
	marginExpired: [],

	depActions: [],
	depUSDTActions: [],
	withActions: [],
	withUSDTActions: [],

	profileActions: [],

	actionsRequiredUnreadCount: 0,
	marginReadUnreadCount: 0,
	depActionsUnreadCount: 0,
	withActionsUnreadCount: 0,
	depActionsUSDTUnreadCount: 0,
	withActionsUSDTUnreadCount: 0,
	profileActionsCount: 0,

	marginActionsNotSeen: new Set(),
	depActionsNotSeen: new Set(),
	withActionsNotSeen: new Set(),
	depActionsUSDTNotSeen: new Set(),
	withActionsUSDTNotSeen: new Set(),
	profileActionsNotSeen: new Set(),
};

const p2pEntryMapper = ({ ref_id, status }) => `${ref_id}${status}`;
// const depActionSorter = (actions, matched, disputed, confirmed, expired) => {
// 	if (Array.isArray(actions) && actions.length > 0) {
// 		actions.forEach(order => {
// 			const { status, exp_time } = order;

// 			switch (status) {
// 				case 0:
// 					if (Date.now() - new Date(exp_time).getTime() > 0) {
// 						matched.push(order);
// 					} else {
// 						expired.push(order);
// 					}
// 					break;

// 				case 5:
// 				case 7:
// 					disputed.push(order);
// 					break;
// 				case 6:
// 					confirmed.push(order);
// 					break;
// 				case 1:
// 					break;
// 				default:
// 					break;
// 			}
// 		});
// 	}
// };
// const withActionSorter = (
// 	actions,
// 	matched,
// 	submitted,
// 	disputed,
// 	expired,
// 	canc
// ) => {
// 	actions.forEach(order => {
// 		const { status, exp_time } = order;

// 		switch (status) {
// 			case 0:
// 				if (Date.now() - new Date(exp_time).getTime() > 0) {
// 					matched.push(order);
// 				} else {
// 					expired.push(order);
// 				}
// 				break;
// 			case 1:
// 				submitted.push(order);
// 				break;
// 			case 5:
// 			case 7:
// 				disputed.push(order);
// 				break;
// 			case 6:
// 				break;
// 			default:
// 				canc.push(order);
// 				break;
// 		}
// 	});
// };

const mergeSNS = (ns, s) => {
	ns.forEach(item => {
		s.add(item);
	});
};

const setLS = (key, val) => {
	if (Array.isArray(val) && val.length === 0) {
		window.localStorage.removeItem(key);
	} else {
		window.localStorage.setItem(key, JSON.stringify(val));
	}
};

const LSSorter = (localKey, unseenSet, seenSet, data) => {
	let parsed = [];
	let latestSeenData = [];

	if (checkDocument) {
		const localValue = window.localStorage.getItem(localKey);

		if (localValue) {
			try {
				parsed = JSON.parse(Harpic(decodeURIComponent(localValue)));

				if (Array.isArray(parsed) && parsed.length > 0) {
					latestSeenData = data.filter(el => parsed.indexOf(el) > -1);

					if (latestSeenData.length > 0) {
						window.localStorage.setItem(
							localKey,
							JSON.stringify(latestSeenData)
						);
					} else {
						window.localStorage.removeItem(localKey);
					}
				}
			} catch (err) {
				console.log(localKey, err);
			}
		}
	}

	data.forEach(order => {
		if (latestSeenData.indexOf(order) === -1) {
			unseenSet.add(order);
		}
	});
	latestSeenData.forEach(item => {
		seenSet.add(item);
	});
};

const getLastSeenActions = (
	marginData,
	depActions,
	withActions,
	depActionsUSDT,
	withActionsUSDT,
	profileActions
) => {
	const marginActionsNotSeen = new Set();
	const depActionsNotSeen = new Set();
	const withActionsNotSeen = new Set();
	const depActionsUSDTNotSeen = new Set();
	const withActionsUSDTNotSeen = new Set();
	const profileActionsNotSeen = new Set();

	LSSorter(
		'marginActionsSeen',
		marginActionsNotSeen,
		marginActionsSeen,
		marginData
	);
	LSSorter('depActionsSeen', depActionsNotSeen, depActionsSeen, depActions);
	LSSorter(
		'withActionsSeen',
		withActionsNotSeen,
		withActionsSeen,
		withActions
	);
	LSSorter(
		'depActionsUSDTSeen',
		depActionsUSDTNotSeen,
		depActionsUSDTSeen,
		depActionsUSDT
	);
	LSSorter(
		'withActionsUSDTSeen',
		withActionsUSDTNotSeen,
		withActionsUSDTSeen,
		withActionsUSDT
	);
	LSSorter(
		'profileActionsSeen',
		profileActionsNotSeen,
		profileActionsSeen,
		profileActions
	);

	return {
		marginActionsNotSeen,
		depActionsNotSeen,
		withActionsNotSeen,
		depActionsUSDTNotSeen,
		withActionsUSDTNotSeen,
		profileActionsNotSeen,
	};
};

const __fetchActionsRequired = async getState => {
	try {
		const { status, data } = await getActionsRequired();

		if (status === 1 && hasOwn(data, 'marginData')) {
			const {
				marginData,
				depWithData: {
					depActions,
					withActions,
					depActionsUSDT,
					withActionsUSDT,
				},
			} = data;
			/**
			 *  For Margin:
			 */
			let marginInFreeze = false;
			let marginInDepo = false;
			const marginAboutToExpire = [];
			const marginExpired = [];
			const marginOnGoing = [];

			if (Array.isArray(marginData) && marginData.length > 0) {
				if (
					marginData.some(
						({ status: marginStatus, phase }) =>
							(marginStatus === 0 && phase === 2) ||
							marginStatus === 2
					)
				) {
					marginInFreeze = true;
					marginOnGoing.push(marginData[0]);
				} else if (
					marginData.some(
						({ status: marginStatus, phase }) =>
							marginStatus === 0 && phase === 1
					)
				) {
					marginInDepo = true;
					marginOnGoing.push(marginData[0]);
				} else {
					marginData.forEach(order => {
						const { expiry, status: marginStatus, phase } = order;

						switch (marginStatus) {
							case 0:
								if (phase === 0) {
									const expiryDate =
										new Date(expiry).getTime() + 19800000;

									if (expiryDate - Date.now() < 0) {
										marginExpired.push(order);
									} else if (
										expiryDate - Date.now() <
										5400000
									) {
										// 1.5 hours
										marginAboutToExpire.push(order);
									} else {
										marginOnGoing.push(order);
									}
								}
								return;
							case 1:
								marginExpired.push(order);
								break;
							default:
								break;
						}
					});
				}
			}

			/**
			 * For P2P
			 */

			// const depMatched = [];
			// const depDisputed = [];
			// const depConfirmed = [];
			// const depExpired = [];

			// const depUSDTMatched = [];
			// const depUSDTDisputed = [];
			// const depUSDTConfirmed = [];
			// const depUSDTExpired = [];

			// const withMatched = [];
			// const withSubmitted = [];
			// const withDisputed = [];
			// const withExpired = [];
			// const withCanc = [];

			// const withUSDTMatched = [];
			// const withUSDTSubmitted = [];
			// const withUSDTDisputed = [];
			// const withUSDTExpired = [];
			// const withUSDTCanc = [];

			/**
			 * BANK
			 */

			/**
			 * Deposit
			 */

			// depActionSorter(
			// 	depActions,
			// 	depMatched,
			// 	depDisputed,
			// 	depConfirmed,
			// 	depExpired
			// );

			// depActionSorter(
			// 	depActionsUSDT,
			// 	depUSDTMatched,
			// 	depUSDTDisputed,
			// 	depUSDTConfirmed,
			// 	depUSDTExpired
			// );

			// withActionSorter(
			// 	withActions,
			// 	withMatched,
			// 	withSubmitted,
			// 	withDisputed,
			// 	withExpired,
			// 	withCanc
			// );

			// withActionSorter(
			// 	withActionsUSDT,
			// 	withUSDTMatched,
			// 	withUSDTSubmitted,
			// 	withUSDTDisputed,
			// 	withUSDTExpired,
			// 	withUSDTCanc
			// );

			/**
			 * FOR Profile
			 */

			const consolidatedProfiles = [];
			const {
				submittedDetails: { phone_verified, video_kyc },
				isVerified,
				process_done,
			} = getState();

			if (isVerified >= 1) {
				if (phone_verified === 0) {
					consolidatedProfiles.push('phone');
				}
				// Video KYC notification only for foreign users
			}
			if ((isVerified > 1 && video_kyc <= 0) || process_done === -9) {
				consolidatedProfiles.push('vkyc');
			}

			const consolidatedMargin =
				marginInFreeze || marginInDepo
					? [marginData[0]]
					: [...marginAboutToExpire, ...marginExpired];
			const consolidatedDeposits = depActions.filter(
				({ status: depStatus }) => depStatus >= 0 && depStatus !== 1
			);
			const consolidatedUSDTDeposits = depActionsUSDT.filter(
				({ status: depStatus }) => depStatus >= 0 && depStatus !== 1
			);

			const consolidatedWithdrawals = withActions.filter(
				({ status: withStatus }) => withStatus !== 6
			);

			const consolidatedUSDTWithdrawals = withActionsUSDT.filter(
				({ status: withStatus }) => withStatus !== 6
			);

			const {
				marginActionsNotSeen,
				depActionsNotSeen,
				withActionsNotSeen,
				depActionsUSDTNotSeen,
				withActionsUSDTNotSeen,
				profileActionsNotSeen,
			} = getLastSeenActions(
				consolidatedMargin.map(
					({ coin, expiry, status: marginStatus, phase }) =>
						`${coin}${expiry}${marginStatus}${phase}`
				),
				consolidatedDeposits.map(p2pEntryMapper),
				consolidatedWithdrawals.map(p2pEntryMapper),
				consolidatedUSDTDeposits.map(p2pEntryMapper),
				consolidatedUSDTWithdrawals.map(p2pEntryMapper),
				consolidatedProfiles
			);

			// const marginActionsNotSeen = consolidatedMargin.map(
			// 	({ coin, expiry, status: marginStatus, phase }) =>
			// 		`${coin}${expiry}${marginStatus}${phase}`
			// );
			// const depActionsNotSeen = consolidatedDeposits.map(p2pEntryMapper);
			// const withActionsNotSeen = consolidatedWithdrawals.map(
			// 	p2pEntryMapper
			// );
			// const depActionsUSDTNotSeen = consolidatedUSDTDeposits.map(
			// 	p2pEntryMapper
			// );
			// const withActionsUSDTNotSeen = consolidatedUSDTWithdrawals.map(
			// 	p2pEntryMapper
			// );

			return {
				marginInFreeze,
				marginInDepo,
				marginAboutToExpire,
				marginExpired,
				marginOnGoing,

				depActions: consolidatedDeposits,
				depUSDTActions: consolidatedUSDTDeposits,
				withActions: consolidatedWithdrawals,
				withUSDTActions: consolidatedUSDTWithdrawals,

				profileActions: consolidatedProfiles,

				marginActionsNotSeen,
				depActionsNotSeen,
				withActionsNotSeen,
				depActionsUSDTNotSeen,
				withActionsUSDTNotSeen,
				profileActionsNotSeen,

				actionsRequiredUnreadCount:
					consolidatedMargin.length +
					consolidatedDeposits.length +
					consolidatedProfiles.length +
					consolidatedWithdrawals.length +
					consolidatedUSDTDeposits.length +
					consolidatedUSDTWithdrawals.length,
			};
		}
	} catch (error) {
		console.log('actionsRequired', error);
	}
	return {};
};

const __setActionsRequiredRead = (
	{
		marginActionsNotSeen,
		depActionsNotSeen,
		depActionsUSDTNotSeen,
		withActionsNotSeen,
		withActionsUSDTNotSeen,
		profileActionsNotSeen,
	},
	actions = '1,2,3,4,5,6'
) => {
	const setRead = {};

	actions.split(',').forEach(action => {
		switch (action) {
			case '1':
				if (marginActionsNotSeen.size > 0) {
					mergeSNS(marginActionsNotSeen, marginActionsSeen);
					setLS('marginActionsSeen', [...marginActionsSeen]);
					setRead.marginActionsNotSeen = new Set();
				}
				break;
			case '2':
				if (depActionsNotSeen.size > 0) {
					mergeSNS(depActionsNotSeen, depActionsSeen);
					setLS('depActionsSeen', [...depActionsSeen]);
					setRead.depActionsNotSeen = new Set();
				}
				break;
			case '3':
				if (depActionsUSDTNotSeen.size > 0) {
					mergeSNS(depActionsUSDTNotSeen, depActionsUSDTSeen);
					setLS('depActionsUSDTSeen', [...depActionsUSDTSeen]);
					setRead.depActionsUSDTNotSeen = new Set();
				}
				break;
			case '4':
				if (withActionsNotSeen.size > 0) {
					mergeSNS(withActionsNotSeen, withActionsSeen);
					setLS('withActionsSeen', [...withActionsSeen]);
					setRead.withActionsNotSeen = new Set();
				}
				break;
			case '5':
				if (withActionsUSDTNotSeen.size > 0) {
					mergeSNS(withActionsUSDTNotSeen, withActionsUSDTSeen);
					setLS('withActionsUSDTSeen', [...withActionsUSDTSeen]);
					setRead.withActionsUSDTNotSeen = new Set();
				}
				break;
			case '6':
				if (profileActionsNotSeen.size > 0) {
					mergeSNS(profileActionsNotSeen, profileActionsSeen);
					setLS('profileActionsSeen', [...profileActionsSeen]);
					setRead.profileActionsNotSeen = new Set();
				}
				break;
			default:
				break;
		}
	});

	return setRead;
};

export const actionsRequiredActions = ({ getState }) => ({
	__fetchActionsRequired: () => __fetchActionsRequired(getState),
	__setActionsRequiredRead,
	__resetActionsRequired: () => initialActionsRequired,
});
